import GlobalProps from 'editor/controls/handlebars/global-props'

export default function (value) {
  const fnTrue = value.fn
  const fnFalse = value.inverse

  return GlobalProps.editable ? fnTrue(this) : fnFalse(this)
}
